import Button from "components/button";
import IconDeliveryTruckWithBackground from "components/icons/icn-delivery-truck-with-background.icon";
import OrdersVolum from "components/orders-pending-volumn";
import { Dialog } from "components/uikit-adapter/index";
import moment from "moment";
import intl from "react-intl-universal";
import { getCardDetailForDailyDelivery } from "services/daily-delivery.service";
import { Container, ContainerActions, DateSpan, Header, Title } from "./styled";

interface DailyDeliveryModalProps {
  open: boolean;
  onClose: () => void;
  date: string;
  familyId: number;
  idUnidadeNegocio: number;
  showVolumes?: boolean;
  handleSearchDailyDeliveries: () => void;
}

export const DailyDeliveryModal = (props: DailyDeliveryModalProps) => {
  const {
    open,
    onClose,
    date,
    familyId,
    idUnidadeNegocio,
    showVolumes = true,
    handleSearchDailyDeliveries,
  } = props;

  const match = {
    params: {
      date: date,
      familyId: familyId.toString(),
      datetype: "0",
    },
  };

  return (
    <Dialog
      title={
        <Header>
          <IconDeliveryTruckWithBackground />
          <Title>{intl.get("dailyDelivery.modal.title")}</Title>
          <DateSpan>{moment(date).format("L")}</DateSpan>
        </Header>
      }
      open={open}
      autoScrollBodyContent
      actions={
        <ContainerActions data-testid="btn-daily-delivery-modal-close">
          <Button
            value={intl.get("geral.buttonsDefault.close")}
            onClick={onClose}
            buttonType="secondary"
            className="buttons"
          />
        </ContainerActions>
      }
    >
      <Container>
        <OrdersVolum
          match={match}
          showVolumes={showVolumes}
          fetchData={(familyId: number, date: string) =>
            getCardDetailForDailyDelivery(familyId, date, idUnidadeNegocio)
          }
          handleSearchDailyDeliveries={handleSearchDailyDeliveries}
        />
      </Container>
    </Dialog>
  );
};

export default DailyDeliveryModal;
